module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }